import { render, staticRenderFns } from "./ConfettiButton.vue?vue&type=template&id=47eab004&scoped=true"
import script from "./ConfettiButton.vue?vue&type=script&lang=ts"
export * from "./ConfettiButton.vue?vue&type=script&lang=ts"
import style0 from "./ConfettiButton.vue?vue&type=style&index=0&id=47eab004&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eab004",
  null
  
)

export default component.exports